import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { ACTION_TYPES } from '../../store/store';
import { completeHostedLogin, UserFacingAuthError } from '../../lib/auth';
import { clearHostedLoginFragment, readHostedLoginResult } from '../../lib/hostedLoginClient';
import { LoadingAnimation } from '../LoadingAnimation';

// Where api-v2's hosted SSO and MFA pages send the browser back to.
export const SsoCallback = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState<string | null>(null);
  // The handoff code is single-use, so it must only be exchanged once.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const result = readHostedLoginResult(window.location.hash);
    clearHostedLoginFragment(window);

    if (!result) {
      setError('The sign-in did not complete. Start again.');
      return;
    }
    if ('error' in result) {
      setError(result.message);
      return;
    }
    completeHostedLogin(result.handoffCode)
      .then(({ authToken, userEmail }) => {
        dispatch({ type: ACTION_TYPES.SET_AUTH_DATA, authData: { authToken, userEmail } });
        window.localStorage.setItem('authToken', authToken);
        window.localStorage.setItem('userEmail', userEmail);
        history.replace('/');
      })
      .catch((err) => {
        console.error(`Cannot complete hosted sign-in: ${err}`);
        setError(err instanceof UserFacingAuthError ? err.message : 'Sign-in could not be completed. Try again.');
      });
  }, [dispatch, history]);

  return (
    <div className="login-container">
      {error ? (
        <>
          <div style={{ paddingBottom: '30px' }}>{error}</div>
          <Link to="/login">Back to sign in</Link>
        </>
      ) : (
        <>
          <div style={{ paddingBottom: '30px' }}>Signing you in...</div>
          <LoadingAnimation color="black" animate={true} sizePx={100} />
        </>
      )}
    </div>
  );
};
